import React, { useEffect } from 'react'
import { BaseNodeProps } from '../../base/types'
import { Handle, Position } from 'reactflow'
import NodeTemplate from '../../base/NodeTemplate'
import { ActionEntityOperationFindOrCreateConfiguration } from './ActionEntityOperationFindOrCreateForm'

const ActionEntityOperationFindOrCreate = React.memo(
  ({
    data,
    isConnectable,
  }: BaseNodeProps<ActionEntityOperationFindOrCreateConfiguration>) => {
    const title = 'Trouver ou créer une entité'
    useEffect(() => {}, [])
    return (
      <>
        <Handle
          type="target"
          position={Position.Left}
          isConnectable={isConnectable}
        />
        <NodeTemplate icon={'database'} title={title} name={data.name} />
        <Handle
          type="source"
          position={Position.Right}
          id="a"
          isConnectable={isConnectable}
        />
      </>
    )
  }
)

export default ActionEntityOperationFindOrCreate
